/**
 * Functional core — pure state transforms for the permissions view UI.
 *
 * No `ref`, no IO: the shell (`definePermissionsView`,
 * `useScrollToPermissionGroup`) reads the current value, calls these, and
 * assigns the result.
 */

/** Toggle `groupName` in the collapsed-groups list. Returns a new array. */
export function toggleCollapsedGroup(
  collapsedGroups: readonly string[],
  groupName: string
): string[] {
  return collapsedGroups.includes(groupName)
    ? collapsedGroups.filter((name) => name !== groupName)
    : [...collapsedGroups, groupName]
}

/** Keep only the groups whose name is not in `hiddenGroupNames`. Read-only. */
export function filterVisibleGroups<T extends { groupName: string }>(
  groups: readonly T[],
  hiddenGroupNames: readonly string[]
): T[] {
  return groups.filter((group) => !hiddenGroupNames.includes(group.groupName))
}
